import { useQuery } from "@tanstack/react-query"

import { getData } from "../services/consulta.service";

export const usePacienteConsultaData = (id) => {

    const pacienteConsultaDataQuery = useQuery({
        queryKey: ['paciente/consulta/data', id],
        queryFn: () => getData(id),
        staleTime: 0, // nulo
    });

    return {
        pacienteConsultaDataQuery,
    }
}